import { Component, OnInit } from '@angular/core';
import { CommonUtilService } from '../service/common-util.service';


@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

  constructor(private commonUtilSvc:CommonUtilService) { }

  ngOnInit(): void {
    this.commonUtilSvc.hideSpinner();
  }

}
